import { useEffect, useState } from "react";
import { LuLoaderCircle } from "react-icons/lu";
import {
  useProjectExportsActions,
  useProjectLatestCompleteExport,
  useProjectLatestExport,
} from "../../core_stores/useProjectExportsStore";
import { useUserSubscription } from "../../core_stores/useSubscriptionStore";
import ProjectExportData from "./component/ProjectExportData";
import ProjectExportStartExport from "./component/ProjectExportStartExport";

export default function ProjectExport() {
  const latestExport = useProjectLatestExport();
  const latestCompleteExport = useProjectLatestCompleteExport();
  const userSubscription = useUserSubscription();

  const { initialize } = useProjectExportsActions();

  const [isInitialized, setIsInitialized] = useState(false);

  const canExport = !userSubscription?.free;

  const initializeData = async () => {
    await initialize();
    setIsInitialized(true);
  };

  useEffect(() => {
    if (canExport) {
      initializeData();
    } else {
      setIsInitialized(true);
    }
  }, []);

  return (
    <div className="h-full flex flex-col gap-8 pl-6 pr-4 pt-6">
      {isInitialized ? (
        <div className="overflow-y-auto flex flex-col gap-8">
          <ProjectExportStartExport canExport={canExport} />

          {canExport && (latestExport || latestCompleteExport) && (
            <div className="flex flex-col gap-8">
              <ProjectExportData />
            </div>
          )}
        </div>
      ) : (
        <div className="flex items-center justify-center flex-1 mb-8">
          <LuLoaderCircle className="animate-spin" size={24} />
        </div>
      )}
    </div>
  );
}
